import React, {useRef, useState, useEffect} from 'react';

import  '@/css/contextmenu.scss';

interface MenuOptions {
    label: string
    onClick: (...props: any) => void
}

interface ContextMenuProps {
    className?: string
    contextLabel: string
    options: MenuOptions[]
    closeOnScrollSelector?:string
}

const ContextMenu = ({className="", contextLabel, options, closeOnScrollSelector}: ContextMenuProps) => {
    const [menuOpen, setMenuOpen] = useState<boolean>(false);
    const [focusedMenuItem, setFocusedMenuItem] = useState<HTMLLIElement>()
    const [elementToFocus, setElementToFocus] = useState<number>(-1)
    const menuButton = useRef<HTMLButtonElement>()
    const menu = useRef<HTMLUListElement>()

    // get c
    let {top, left} = menuButton.current 
        ? menuButton.current.getBoundingClientRect() : {top: 0, left: 0}

    useEffect(() => {
        function closeMenu() {
            setFocusedMenuItem(undefined);
            setMenuOpen(false);
           
        }
        if (closeOnScrollSelector) {
            document.querySelector(closeOnScrollSelector)?.addEventListener('scroll',() =>  closeMenu());
            return () => {
                document.querySelector(closeOnScrollSelector)?.removeEventListener('scroll',() => closeMenu());
            }
        }
    }, [])

    useEffect(()=> {
        if (focusedMenuItem) {
            focusedMenuItem.focus();
        }
    },[focusedMenuItem]);

    useEffect(()=> {
        if (elementToFocus >= 0){
            
            if(menu.current) {
                focusMenuItem(0)
            }
        }
    },[elementToFocus])

    function handleBlur(e: React.FocusEvent){
        if(!e.currentTarget.closest('.context-menu-wrapper').contains(e.relatedTarget as Node)) {
            setFocusedMenuItem(undefined);
            setMenuOpen(false);
            setElementToFocus(-1);
        }
    } 

    function focusMenuItem(increment: number ) {
        setElementToFocus(-1);
        const selectableElements = Array.from(menu.current.children);
        const idx = focusedMenuItem ? selectableElements.findIndex((element)=> element ===  focusedMenuItem) : 0;  
        setFocusedMenuItem(selectableElements[idx + increment] as HTMLLIElement);
    }

    function handleMenuKeyPress(e:React.KeyboardEvent) {
        switch(e.key) { 
            default: 
                setMenuOpen(false);
                break;
        }
    }

    function handleOpen(e: React.MouseEvent) {
        if (!e.nativeEvent.clientY &&  !e.nativeEvent.clientX ) {
            setElementToFocus(0);   
        }
        setMenuOpen(!menuOpen);
    }

    function handleInMenuKeyPress(e:React.KeyboardEvent, action) {
        const selectableElements = Array.from(menu.current.children);
        const idx = selectableElements.findIndex((element)=> element ===  focusedMenuItem);
        switch(e.key){
            case 'ArrowUp':
                e.preventDefault();
                if (idx >= 1) {
                    focusMenuItem(-1);
                }
                break;
            case 'ArrowDown':
                e.preventDefault();
                if (idx + 1  < selectableElements.length ) {
                    focusMenuItem(1);
                } 
                break;
            case ' ':
            case 'Enter':
                action()
                setMenuOpen(false);
                break;
            case 'Escape':
                setMenuOpen(false);
                menuButton.current.focus();
                break;
        }
    }

    return (
        <div className={`context-menu-wrapper${" " + className}`}>
            <button
                ref={menuButton}
                onBlur={handleBlur}
                onClick={handleOpen}
                onKeyDown={handleMenuKeyPress}
                aria-expanded={menuOpen}
                aria-label={contextLabel}
                aria-haspopup="menu"
            >
                ...
            </button>
            {menuOpen &&
                <ul 
                    role="menu"
                    ref={menu}
                    className={`context-options`}
                    aria-labelledby="`context-options" 
                    style={{top: top + 10, left: left + 10}} 
                >
                {options.map((option, idx) =>    
                    <li     
                        onBlur={handleBlur}
                        key={`context-options-${idx+1}`}
                        onKeyDown={(e)=> handleInMenuKeyPress(e, option.onClick)}
                        role="menuitem"
                        tabIndex={-1}
                        onClick={()=> {
                            option.onClick();
                            setMenuOpen(false);
                        }}
                    >
                        {option.label}
                    </li>
                )}
                </ul>
            }

        </div>
    )
}

export default ContextMenu